import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Card, Spinner, Alert, Accordion } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { selectUserDetails } from '../../redux/slices/userSlice';
import useSendEmail from '../../functions/useSendEmail';
import useUserContact from '../../functions/useUserContact';
import { formatDateForEmail } from '../../utils/dateUtils';

const ScheduleNotificationModal = ({ 
  show, 
  onHide, 
  jobData, 
  onNotificationSent,
  onSaveOnly 
}) => {
  console.log('ScheduleNotificationModal - show prop:', show);
  console.log('ScheduleNotificationModal - jobData:', jobData);
  
  const userDetails = useSelector(selectUserDetails);
  const [emailSubject, setEmailSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState({ show: false, type: '', message: '' });
  const [additionalToEmails, setAdditionalToEmails] = useState('');
  const [additionalCcEmails, setAdditionalCcEmails] = useState('zack.sukys@watertronics.com');
  const sendEmail = useSendEmail();
  const { userContacts, loading: contactsLoading, error: contactsError } = useUserContact();
  // Initialize email content when modal opens
  useEffect(() => {
    console.log('ScheduleNotificationModal useEffect - show:', show, 'jobData:', jobData);
    if (show && jobData) {
      const subject = `${jobData.JobNumber || 'N/A'} ${jobData.ProjectName || 'N/A'} - Release to Production/ Engineering`;
      setEmailSubject(subject);

      const body = generateEmailBody(jobData);
      setEmailBody(body);
    }
  }, [show, jobData]);  const generateEmailBody = (job) => {
    const formatDate = (dateString) => {
      if (!dateString) return 'Not specified';
      // Use the unified date formatting for emails
      return formatDateForEmail(dateString);
    };

    return `
<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
  <h4 style="color: #2c5aa0; border-bottom: 2px solid #2c5aa0; padding-bottom: 10px;">
    <strong> ${job.JobNumber || 'N/A'} - ${job.ProjectName || 'N/A'} </strong> has been released to engineering/ production
  </h4>
  </br>

<h4>Job Details</h4>
<strong>Release Status: </strong>${job.JobStatus || 'N/A'}<br>
  <strong>Model Number: </strong>${job.ModelNumber || 'N/A'}<br>
    <strong>Engineering Release Date: </strong>${formatDate(job.ProductionRelease)}<br>
    <strong>Current Plan Ship Date: </strong>${formatDate(job.CurrentPlanShipDate)}<br>
    <strong>Scheduled Arrival Date: </strong>${formatDate(job.ScheduledArrivalDate)}<br>
</br>
</br>  ${job.MechanicalEngineer || job.ElectricalEngineer || job.ControlsEngineer ? `
  <h4>Assigned Engineers:</h4>
  ${job.MechanicalEngineer ? `<strong>Mechanical Engineer: </strong>${job.MechanicalEngineer}<br>` : ''}
  ${job.ElectricalEngineer ? `<strong>Electrical Engineer: </strong>${job.ElectricalEngineer}<br>` : ''}
  ${job.ControlsEngineer ? `<strong>Controls Engineer: </strong>${job.ControlsEngineer}<br>` : ''}
  ` : ''}
  
  
  <p style="font-size: 12px; color: #666; margin-top: 30px; border-top: 1px solid #ddd; padding-top: 15px;">
    This is an automated notification from the Production Portal.
  </p>
</div>
    `.trim();
  };
  const getRecipientEmails = () => {
    const toRecipients = [];
    const ccRecipients = [];

    // Helper function to find email by name in a group
    const findEmailByName = (groupContacts, personName) => {
      if (!groupContacts || !personName) return null;
      const contact = groupContacts.find(contact => 
        contact.name && contact.name.toLowerCase() === personName.toLowerCase()
      );
      return contact && contact.email !== 'N/A' ? contact.email : null;
    };    // Add all assigned recipients automatically
    const recipientRoles = [
      { role: 'projectManager', personName: jobData?.ProjectManager, groupContacts: userContacts.projectManager || [] },
      { role: 'sales', personName: jobData?.SalesRep, groupContacts: userContacts.sales || [] },
      { role: 'mechanicalEngineer', personName: jobData?.MechanicalEngineer, groupContacts: userContacts.mechanicalEngineer || [] },
      { role: 'electricalEngineer', personName: jobData?.ElectricalEngineer, groupContacts: userContacts.electricalEngineer || [] },
      { role: 'controlsEngineer', personName: jobData?.ControlsEngineer, groupContacts: userContacts.controlsEngineer || [] }
    ];

    for (const { role, personName, groupContacts } of recipientRoles) {
      if (personName) {
        try {
          const email = findEmailByName(groupContacts, personName);
          if (email) {
            toRecipients.push(email);
          } else {
            console.warn(`Could not find email for ${personName} in ${role} group`);
          }
        } catch (error) {
          console.warn(`Error getting contact for ${role}:`, error);
        }
      }
    }

    // Add additional TO recipients
    if (additionalToEmails.trim()) {
      const additionalTos = additionalToEmails.split(/[,;\s]+/).filter(email => email.trim());
      toRecipients.push(...additionalTos);
    }

    // Add additional CC recipients
    if (additionalCcEmails.trim()) {
      const additionalCcs = additionalCcEmails.split(/[,;\s]+/).filter(email => email.trim());
      ccRecipients.push(...additionalCcs);
    }

    return { toRecipients, ccRecipients };
  };const handleSendNotification = async () => {
    setIsLoading(true);
    setNotification({ show: false, type: '', message: '' });

    try {
      const { toRecipients, ccRecipients } = getRecipientEmails();

      if (toRecipients.length === 0 && ccRecipients.length === 0) {
        throw new Error('No recipients selected. Please select at least one recipient.');
      }      await sendEmail({
        subject: emailSubject,
        body: emailBody,
        toRecipients,
        ccRecipients,
        from: userDetails?.username
      });

      setNotification({
        show: true,
        type: 'success',
        message: 'Notification sent successfully!'
      });

      // Call the callback to notify parent component
      if (onNotificationSent) {
        onNotificationSent();
      }

      // Close modal after a brief delay
      setTimeout(() => {
        onHide();
      }, 1500);

    } catch (error) {
      console.error('Error sending notification:', error);
      setNotification({
        show: true,
        type: 'danger',
        message: `Failed to send notification: ${error.message}`
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveOnly = () => {
    // Call the save only callback to notify parent component to perform the save without email
    if (onSaveOnly) {
      onSaveOnly();
    }
    
    // Close the modal
    onHide();
  };

  const recipientOptions = [
    { key: 'projectManager', label: 'Project Manager', person: jobData?.ProjectManager },
    { key: 'sales', label: 'Sales Rep', person: jobData?.SalesRep },
    { key: 'mechanicalEngineer', label: 'Mechanical Engineer', person: jobData?.MechanicalEngineer },
    { key: 'electricalEngineer', label: 'Electrical Engineer', person: jobData?.ElectricalEngineer },
    { key: 'controlsEngineer', label: 'Controls Engineer', person: jobData?.ControlsEngineer }
  ];

  // Helper function to get email for a person
  const getEmailForPerson = (role, personName) => {
    if (!userContacts || !userContacts[role] || !personName) return null;
    const contact = userContacts[role].find(contact => 
      contact.name && contact.name.toLowerCase() === personName.toLowerCase()
    );
    return contact && contact.email !== 'N/A' ? contact.email : null;
  };

  return (
    <Modal className="job-schedule-modal" show={show} onHide={onHide} size="lg" backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>Send Schedule Notification</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {notification.show && (
          <Alert variant={notification.type} className="mb-3">
            {notification.message}
          </Alert>
        )}

        <p className="mb-3">Please choose how you would like to proceed with scheduling this job:</p>

        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>Email Preview & Recipients</Accordion.Header>
            <Accordion.Body>
              {contactsError && (
                <Alert variant="warning" className="mb-3">
                  Warning: Unable to load team member contacts. You may need to manually add email addresses.
                </Alert>
              )}

              {contactsLoading ? (
                <div className="text-center py-3">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading contacts...</span>
                  </Spinner>
                  <p className="mt-2">Loading team member contacts...</p>
                </div>
              ) : (
                <Form>                  <Row>
                    <Col md={12}>
                      <Card className="mb-3">
                        <Card.Header>
                          <h6 className="mb-0">Default Email Recipients</h6>
                        </Card.Header>
                        <Card.Body>
                          <div className="mb-3">
                            <strong>The following recipients will automatically receive the notification:</strong>
                          </div>
                          {recipientOptions
                            .filter(option => option.person) // Only show recipients that have assigned people
                            .map(option => {
                              const email = getEmailForPerson(option.key, option.person);
                              return (
                                <div key={option.key} className="mb-2">
                                  <span className="badge bg-primary me-2">
                                    {option.label}: {option.person} {email ? `(${email})` : '(email not found)'}
                                  </span>
                                </div>
                              );
                            })}
                          
                          {recipientOptions.filter(option => option.person).length === 0 && (
                            <div className="text-muted">
                              <em>No recipients assigned for this job.</em>
                            </div>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <Card className="mb-3">
                        <Card.Header>
                          <h6 className="mb-0">Additional Recipients</h6>
                        </Card.Header>
                        <Card.Body>
                          <Form.Group className="mb-3">
                            <Form.Label>Additional TO Recipients:</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter email addresses separated by commas"
                              value={additionalToEmails}
                              onChange={(e) => setAdditionalToEmails(e.target.value)}
                            />
                            <Form.Text className="text-muted">
                              Add email addresses separated by commas (e.g., john@example.com, jane@example.com)
                            </Form.Text>
                          </Form.Group>

                          <Form.Group>
                            <Form.Label>CC Recipients:</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter email addresses separated by commas"
                              value={additionalCcEmails}
                              onChange={(e) => setAdditionalCcEmails(e.target.value)}
                            />
                            <Form.Text className="text-muted">
                              Add email addresses separated by commas. 
                            </Form.Text>
                          </Form.Group>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Subject:</Form.Label>
                        <Form.Control
                          type="text"
                          value={emailSubject}
                          onChange={(e) => setEmailSubject(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Message Preview:</Form.Label>
                        <div 
                          style={{
                            border: '1px solid #ced4da',
                            borderRadius: '0.375rem',
                            padding: '15px',
                            backgroundColor: '#f8f9fa',
                            maxHeight: '400px',
                            overflowY: 'auto'
                          }}
                          dangerouslySetInnerHTML={{ __html: emailBody }}
                        />
                        <Form.Text className="text-muted">
                          This is a preview of the email message that will be sent. The content is automatically generated based on job details.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Modal.Body>      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isLoading}>
          Cancel
        </Button>
        <Button 
          variant="outline-primary" 
          onClick={handleSaveOnly}
          disabled={isLoading}
        >
          Save Only
        </Button>
        <Button 
          variant="primary" 
          onClick={handleSendNotification}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Sending...
            </>
          ) : (
            'Send Notification'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ScheduleNotificationModal;
